import { useMemo } from 'react';
import { usePermissions } from 'context/PermissionsContext';
import { MESSAGING_PERMISSION_CODES } from 'permissions/constants/messagingPermissionCodes';
import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export { MESSAGING_PERMISSION_CODES };

const usePermissionsMessaging = () => {
  const { permissionsLoading, hasPermission, hasModuleAccess } =
    usePermissions();

  return useMemo(
    () => ({
      loading: permissionsLoading,
      canAccessModule: hasModuleAccess(MODULE_KEY_MAP.MESSAGING),
      canViewSection: hasPermission(MESSAGING_PERMISSION_CODES.VIEW_SECTION),
      canCreateMessage: hasPermission(
        MESSAGING_PERMISSION_CODES.CREATE_MESSAGE
      ),
      canViewSectionTemplates: hasPermission(
        MESSAGING_PERMISSION_CODES.VIEW_SECTION_TEMPLATES
      ),
      canCreateTemplate: hasPermission(
        MESSAGING_PERMISSION_CODES.CREATE_TEMPLATE
      ),
      canPreviewTemplate: hasPermission(
        MESSAGING_PERMISSION_CODES.PREVIEW_TEMPLATE
      ),
      canEditTemplate: hasPermission(MESSAGING_PERMISSION_CODES.EDIT_TEMPLATE),
      canDeleteTemplate: hasPermission(
        MESSAGING_PERMISSION_CODES.DELETE_TEMPLATE
      ),
      canAccessCampaigns: hasPermission(MESSAGING_PERMISSION_CODES.CAMPAIGNS),
      canViewSectionCampaigns: hasPermission(
        MESSAGING_PERMISSION_CODES.VIEW_SECTION_CAMPAIGNS
      ),
      canCreateCampaign: hasPermission(
        MESSAGING_PERMISSION_CODES.CREATE_CAMPAIGN
      ),
      canViewCampaign: hasPermission(MESSAGING_PERMISSION_CODES.VIEW_CAMPAIGN),
      canDeleteCampaign: hasPermission(
        MESSAGING_PERMISSION_CODES.DELETE_CAMPAIGN
      ),
      canAccessTasksAndNotifications: hasPermission(
        MESSAGING_PERMISSION_CODES.TASKS_AND_NOTIFICATIONS
      ),
      canViewSectionTasks: hasPermission(
        MESSAGING_PERMISSION_CODES.VIEW_SECTION_TASKS
      ),
      canCreateTask: hasPermission(MESSAGING_PERMISSION_CODES.CREATE_TASK),
      canEditTask: hasPermission(MESSAGING_PERMISSION_CODES.EDIT_TASK),
      canDeleteTask: hasPermission(MESSAGING_PERMISSION_CODES.DELETE_TASK),
    }),
    [permissionsLoading, hasPermission, hasModuleAccess]
  );
};

export default usePermissionsMessaging;
